// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBmtNMaj2iUAsVY-kEJ8Rl566hoNX8iTyI",
  authDomain: "jinyang-web.firebaseapp.com",
  projectId: "jinyang-web",
  storageBucket: "jinyang-web.firebasestorage.app",
  messagingSenderId: "1033551497346",
  appId: "1:1033551497346:web:ed116285aaad96a257cc9b",
  measurementId: "G-04NXJ6E9HD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


if (process.env.NODE_ENV === 'development') {
  // 로컬 테스트용 디버그 토큰
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = "5F7846C4-3666-4ED1-8B60-47F2394573C2"; 
}

try {
  initializeAppCheck(app, {
    // --- 이 부분의 키를 방금 복사한 새로운 키로 교체해주세요 ---
    provider: new ReCaptchaEnterpriseProvider ('6LewoGMrAAAAAFUuWSG1cubAaY0swyDHSN3Ivyd1'), 
    isTokenAutoRefreshEnabled: true
  });
  console.log("Firebase App Check initialized successfully.");
} catch (error) {
  console.error("Error initializing Firebase App Check:", error);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;

/*
storage, firedatabase 권한 수정 필요
*/